import { Injectable } from '@angular/core';
import { SocketMessage } from 'src/app/system/utility/websocket.service';
import { logger } from '../logging/logging.service';
import { ChatMessage } from '../../components/chat/chat-message';
import { ChatUtility } from '../../components/chat/chat-utility';

@Injectable({
  providedIn: 'root'
})
export class HelpDeskDispatcherService {

  private dispatcher!: ((message: ChatMessage) => void) | null;

  public registerDispatcher(func: (message: ChatMessage) => void) {
    this.dispatcher = func;
  }

  public unregisterDispatcher() {
    this.dispatcher = null;
  }

  public handleMessage(data: SocketMessage) {
    logger.debug("HelpDeskDispatcherService: handleMessage", data);
    let message = ChatUtility.parseSocketMessage(data.message);
    if (this.dispatcher) {
      this.dispatcher(message);
    }
    else {
      logger.error("HelpDeskDispatcherService: No dispatcher registered", data.message);
    }
  }
}